import Modal, { ModalProps } from './Modal';

import Button from '../common/Button';
import { Fragment } from 'react';
import { SdpResponse } from '../../models/SdpResponse';
import { useTranslation } from 'react-i18next';

export interface ModalForecastHistoryProps extends ModalProps {
  sdp?: SdpResponse | null;
}
export default function ModalForecastHistory({
  isOpen,
  onClickAction,
  onClose,
}: ModalForecastHistoryProps) {
  const { t } = useTranslation();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      actions={
        <Fragment>
          <Button className="btn btn--secondary" onClick={onClickAction}>
            {t('common.close')}
          </Button>
        </Fragment>
      }
    >
      <Fragment>
        <h2 className="modal__title">{t('modal.forecast.history.title')}</h2>
        <div className="modal__message">{t('modal.forecast.history.message')}</div>
      </Fragment>
    </Modal>
  );
}
